import { ContentType } from '../../enums/contentType';
import { CustomKeyValue, LanguageKeys } from '../interfaces/common.interface';

export const dolbyAudioQualities = [
  'Dolby5.1',
  'Dolby5.1+',
  'DolbyAudio',
  'Dolby audio',
  'DOLBY',
  'dolby',
  '5.1',
];

export const AUDIO_QUALITIES = {
  DOLBY_AUDIO: 'Dolby Audio',
  DOLBY_ATMOS: 'Dolby Atmos',
  STEREO: 'Stereo',
};

export const dolbyAtmosQualities = ['DolbyAtmos'];

export const AQ_ATMOS = 'eac3-joc';
export const AQ_DOLBY = 'eac3';
export const AQ_STEREO = 'stereo';
export const AUDIO_DOLBY = 'ec-3';

export const advisoriesConfig = {
  AC: 'Adult Content',
  GL: 'Graphic Language',
  MV: 'Mild Violence',
  GV: 'Graphic Violence',
  N: 'Nudity',
  SSC: 'Strong Sexual Content',
  RP: 'Rape',
  MS: 'Mild Substances',
  SS: 'Substances',
  VE: 'Violence',
  SC: 'Sexual Content',
  NY: 'Nudity',
  SL: 'Strong Language',
  SH: 'Self-harm',
  SV: 'Sexual Violence',
  FG: 'Feel-good',
  IN: 'Inspiring',
  HU: 'Humorous',
  RO: 'Romantic',
  AD: 'Adventurous',
  ED: 'Educational',
  MY: 'Mythological',
  HF: 'Heartfelt',
  AL: 'Aspirational',
  PC: 'Patriotic',
  EL: 'Emotional',
  EG: 'Exciting',
  MR: 'Mystery',
  PL: 'Political',
  SF: 'Suspenseful',
  IF: 'Informational',
};

export const hasEpisodeTypes = [
  ContentType.TV_SERIES,
  ContentType.TV_SEASON,
  ContentType.TV_EPISODE,
  ContentType.WEB_SERIES,
  ContentType.WEB_SEASON,
  ContentType.WEB_EPISODE,
];

export const isSeriesType = [ContentType.TV_SERIES, ContentType.WEB_SERIES];
export const isEpisodeType = [ContentType.TV_EPISODE, ContentType.WEB_EPISODE];
export const isDirectPlayableTypes = [
  ContentType.LIVE_CHANNEL,
  ContentType.LIVE_EVENT,
  ContentType.CHANNEL,
  ContentType.SHORT_VIDEO,
  ContentType.TRAILER,
];

export const TAMIL = 'tamil';
export const TELUGU = 'telugu';
export const TAMIL_ACL = 'tm';
export const TELUGU_ACL = 'tg';

export const AUDIO_DOLBY_ATMOS = 'dolbyatmos';
export const AUDIO_DOLBY_AUDIO = 'dolbyaudio';
export const AUDIO_51 = '5.1';

export const LANG: Record<LanguageKeys, CustomKeyValue> = {
  TM: { k: 'ta', v: 'Tamil' },
  TG: { k: 'te', v: 'Telugu' },
  EN: { k: 'en', v: 'English' },
};

export enum PlayerContainerType {
  EPISODES = 'episodes',
  RELATED_ITEMS = 'relatedItems',
}

export const IN_APP_BANNER_ID = 'in-app-banner';
